import React from "react";

const ClosedVenueTag: React.FC<any> = (props: any) => {
    return (
        <div className="col-6 pb-2">
            <React.Fragment>
                <span className="badge badge-secondary pr-3 p-2 closed-acces-badge mb-0">
                <svg
                    className="bi bi-lock-fill mr-2"
                    width="1em"
                    height="1em"
                    viewBox="0 0 14 14"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="11" height="9" x="2.5" y="7" rx="2" />
                    <path
                    fillRule="evenodd"
                    d="M4.5 4a3.5 3.5 0 1 1 7 0v3h-1V4a2.5 2.5 0 0 0-5 0v3h-1V4z"
                    />
                </svg>
                Accés tancat
                </span>
            </React.Fragment>
        </div>
    );
};

export default ClosedVenueTag;